module.exports = __webpack_public_path__ + "static/media/quote-homebg.ac4ef76e.png";